import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { MascotPortrait } from "@/components/Mascot";
import { api } from "@/lib/api";
import { useGame } from "@/context/GameContext";

const BURST = Array.from({ length: 14 }, (_, i) => ({ a: (360 / 14) * i, d: 70 + (i % 3) * 22, c: ["#fcd34d", "#f59e0b", "#fde68a"][i % 3] }));

export default function WelcomeBonus() {
  const { user, refresh } = useGame();
  const [amount, setAmount] = useState(0);
  const nav = useNavigate();
  useEffect(() => {
    if (!user) return;
    api.get("/welcome").then(({ data }) => data.show && setAmount(data.amount)).catch(() => {});
  }, [user?.user_id]); // eslint-disable-line react-hooks/exhaustive-deps
  const close = async (go) => {
    setAmount(0);
    await api.post("/welcome/seen").catch(() => {});
    refresh();
    if (go) nav("/journey");
  };
  if (!amount) return null;
  return (
    <Dialog open onOpenChange={(o) => !o && close(false)}>
      <DialogContent data-testid="welcome-bonus-popup" className="glass max-w-md text-center overflow-hidden">
        <div className="relative mx-auto w-28 h-28 grid place-items-center mt-2">
          {BURST.map((b, i) => (
            <span key={b.a} className="welcome-spark absolute w-2 h-2 rounded-full" style={{ background: b.c, "--a": `${b.a}deg`, "--d": `${b.d}px`, animationDelay: `${0.15 + (i % 4) * 0.05}s` }} />
          ))}
          <MascotPortrait size="w-24 h-24" />
        </div>
        <p className="text-[11px] font-mono-game text-amber-300 tracking-[0.3em] mt-2">KING WOLF SAYS</p>
        <DialogTitle className="font-display text-3xl text-amber-100">Welcome to the pack!</DialogTitle>
        <p data-testid="welcome-bonus-amount" className="font-display text-5xl text-amber-300 drop-shadow-[0_0_18px_rgba(252,211,77,0.45)] chest-pop">+{amount.toLocaleString()}</p>
        <p className="text-xs font-mono-game text-amber-200/80 -mt-2">CREDITS</p>
        <DialogDescription className="text-slate-300 leading-relaxed">
          You're one of our first 100 players, so here's {amount.toLocaleString()} credits to get you started. Spend them on energy, revives or a one-of-a-kind 1/1 look.
        </DialogDescription>
        <button data-testid="welcome-bonus-start" onClick={() => close(true)} className="ember-btn w-full py-3 rounded-full text-sm mt-2">START MY JOURNEY</button>
      </DialogContent>
    </Dialog>
  );
}
